import { TGalleryItem } from "./index.d";

export const ITEMS: TGalleryItem[] = [
  // type video
  {
    src: "https://videos.pexels.com/video-files/3195394/3195394-uhd_2560_1440_25fps.mp4",
    thumbnail: "https://img.youtube.com/vi/7e90gBu4pas/hqdefault.jpg",
    type: "video",
  },
  {
    src: "https://videos.pexels.com/video-files/3195394/3195394-uhd_2560_1440_25fps.mp4",
    thumbnail: "https://img.youtube.com/vi/7e90gBu4pas/hqdefault.jpg",
    type: "video",
  },
  // type photo, link from https://placehold.co/ random size
  {
    src: "https://placehold.co/640x400",
    thumbnail: "https://placehold.co/640x400",
    type: "photo",
  },
  {
    src: "https://placehold.co/640x360",
    thumbnail: "https://placehold.co/640x360",
    type: "photo",
  },
  {
    src: "https://placehold.co/640x960",
    thumbnail: "https://placehold.co/640x960",
    type: "photo",
  },
  {
    src: "https://placehold.co/640x360",
    thumbnail: "https://placehold.co/640x360",
    type: "photo",
  },
  {
    src: "https://placehold.co/640x360",
    thumbnail: "https://placehold.co/640x360",
    type: "photo",
  },
  {
    src: "https://placehold.co/640x360",
    thumbnail: "https://placehold.co/640x360",
    type: "photo",
  },
  {
    src: "https://placehold.co/640x360",
    thumbnail: "https://placehold.co/640x360",
    type: "photo",
  },
  {
    src: "https://placehold.co/640x360",
    thumbnail: "https://placehold.co/640x360",
    type: "photo",
  },
  {
    src: "https://placehold.co/640x360",
    thumbnail: "https://placehold.co/640x360",
    type: "photo",
  },
  {
    src: "https://placehold.co/640x360",
    thumbnail: "https://placehold.co/640x360",
    type: "photo",
  },
]

export const ITEMS_2: TGalleryItem[] = [
  {
    src: "https://placehold.co/640x360",
    thumbnail: "https://placehold.co/640x360",
    type: "photo",
  },
]

export const ITEMS_3: TGalleryItem[] = [
  {
    src: "https://placehold.co/640x360",
    thumbnail: "https://placehold.co/640x360",
    type: "photo",
  },
  {
    src: "https://placehold.co/640x360",
    thumbnail: "https://placehold.co/640x360",
    type: "photo",
  },
  {
    src: "https://placehold.co/640x360",
    thumbnail: "https://placehold.co/640x360",
    type: "photo",
  },
]
